import Blue from "~/core";
import TabsManual from "~/components/_tabsManual";

new Blue({
  name: 'Sponsorship Tab',
  selector: ".sponsorship-tab",
  setup(sponsorshipTab) {
    const tablists = sponsorshipTab.querySelectorAll('[role=tablist]')
    const tabs = sponsorshipTab.querySelectorAll('[role=tab]')
    const tabpanels = sponsorshipTab.querySelectorAll('.sponsorship-tab__tabpanel')

    tablists.forEach(e => {
      new TabsManual(e)
    })
  }
});